// ═══ 검차 신청 폼의 순수 로직 — 상수·정규화·FormData·중복 선검사·OCR 프리필 ═══
// 화면(SimpleNewRequest.js)에서 떼어낸 부분. React 상태를 모르는 순수 함수만 둔다.
import { FUELS } from './StepVehicle';

// 진행 중으로 보는 상태 — 서버 중복 판정 범위(routes/eval-orders.js POST /)와 같은 집합.
export var OPEN_STATUSES = ['open', 'taken', 'inspecting', 'completed'];
export var MAX_PHOTOS = 3;
export var DEFAULT_FEE = 75000;
// 성공 토스트를 잠깐 보여준 뒤 목록으로 — 앱의 스낵 + go('/s/requests') 대응.
export var NAV_DELAY = 700;

export var EMPTY_FORM = {
  car_model: '', car_detail: '', car_number: '', car_year: '', car_mileage: '',
  car_fuel: '가솔린', seller_phone: '', location: '', location_detail: '', listing_url: '', memo: ''
};

var FUEL_VALUES = FUELS.map(function (f) { return f.value; });

/// http/https 만 허용하고 scheme·host 를 소문자로 정규화. 아니면 '' (앱 normalizeListingUrl).
export function normalizeListingUrl(raw) {
  var s = String(raw || '').trim();
  if (!s) return '';
  try {
    var u = new URL(s);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    return u.toString();
  } catch (e) { return ''; }
}

export function hostOf(url) {
  try { return new URL(url).hostname.replace(/^www\./i, ''); } catch (e) { return ''; }
}

export function isOpen(order) { return OPEN_STATUSES.indexOf(order && order.status) >= 0; }

/// 메모 + OCR 요약을 한 notes 로. 빈 줄은 넣지 않는다.
export function joinNotes(memo, ocrNotes) {
  return [String(memo || '').trim(), String(ocrNotes || '').trim()].filter(Boolean).join('\n');
}

/// 빈 값·'0' 은 보내지 않는다(서버가 0 을 유효값으로 읽지 않게).
export function buildBody(fields, files) {
  var fd = new FormData();
  Object.keys(fields).forEach(function (k) {
    var v = fields[k];
    if (v === undefined || v === null) return;
    var s = String(v).trim();
    if (!s || s === '0') return;
    fd.append(k, s);
  });
  (files || []).forEach(function (p) { fd.append('photos', p.file, p.name); });
  return fd;
}

/// 진행 중 목록에서 같은 차량번호·매물링크 건 찾기(클라 선검사 — 최종 판정은 서버).
export function findDup(orders, key, value) {
  var list = orders || [];
  for (var i = 0; i < list.length; i += 1) {
    var o = list[i];
    if (!isOpen(o)) continue;
    if (key === 'car_number' && String(o.car_number || '').trim() === value) return o;
    if (key === 'listing_url' && normalizeListingUrl(o.listing_url) === value) return o;
  }
  return null;
}

/// OCR 응답(d)을 폼에 얹는다 — 빈 값은 기존 입력을 덮지 않는다.
export function ocrPrefill(prev, d) {
  return Object.assign({}, prev, {
    car_model: d.carModel || prev.car_model,
    car_detail: d.carDetail || prev.car_detail,
    car_number: d.carNumber || prev.car_number,
    car_year: Number(d.carYear) > 0 ? String(d.carYear) : prev.car_year,
    car_mileage: Number(d.carMileage) > 0 ? String(d.carMileage) : prev.car_mileage,
    car_fuel: FUEL_VALUES.indexOf(d.carFuel) >= 0 ? d.carFuel : prev.car_fuel,
    seller_phone: d.sellerPhone || prev.seller_phone,
    location: d.location || prev.location
  });
}
